import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "container mx-auto p-2" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", { class: "text-3xl font-bold" }, "写真を選んで管理", -1);
const _hoisted_3 = { class: "flex flex-row flex-wrap py-4" };
const _hoisted_4 = { class: "w-full px-2 text-left sm:w-1/3 md:w-1/4" };
const _hoisted_5 = { class: "sticky top-0 w-full rounded-xl bg-white p-4" };
const _hoisted_6 = { class: "nav flex flex-col overflow-hidden" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-lg font-semibold" }, "写真のステータスを変更する", -1);
const _hoisted_8 = ["id", "value"];
const _hoisted_9 = ["for"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-lg font-semibold" }, "写真にタグをつける／変更する", -1);
const _hoisted_12 = ["checked", "indeterminate", "onClick"];
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "m-2" }, "すべて選択する", -1);
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "m-2" }, "選択を解除する", -1);
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = ["disabled"];
const _hoisted_19 = { class: "m-2" };
const _hoisted_20 = { key: 0 };
const _hoisted_21 = { key: 1 };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_23 = { class: "mt-3" };
const _hoisted_24 = {
    role: "main",
    class: "w-full px-2 pt-1 sm:w-2/3 md:w-3/4"
};
const _hoisted_25 = { class: "flex flex-wrap" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = { key: 0 };
const _hoisted_28 = ["src"];
const _hoisted_29 = { class: "leading-6" };
const _hoisted_30 = { key: 1 };
const _hoisted_31 = ["src"];
const _hoisted_32 = { class: "leading-6" };
const _hoisted_33 = { key: 0 };
const _hoisted_34 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LinkButton = _resolveComponent("LinkButton");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("aside", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("ul", _hoisted_6, [
                        _hoisted_7,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoFilters, (filter, k) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "nav-item",
                                key: k
                            }, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "photoFilter",
                                    id: filter.key,
                                    value: filter.photoStatus,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedPhotoFilter) = $event))
                                }, null, 8, _hoisted_8), [
                                    [_vModelRadio, _ctx.selectedPhotoFilter]
                                ]),
                                _createElementVNode("label", {
                                    for: filter.key
                                }, _toDisplayString(filter.name), 9, _hoisted_9)
                            ]));
                        }), 128))
                    ]),
                    _hoisted_10,
                    _hoisted_11,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTags, (tag, k) => {
                        return (_openBlock(), _createElementBlock("div", { key: k }, [
                            _createElementVNode("div", {
                                class: "m-px inline-block h-3 w-3 rounded-md",
                                style: _normalizeStyle({ 'background-color': tag.color })
                            }, null, 4),
                            _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.selectedPhotoIdsIndexedByTagId[tag.id] &&
                                    Object.keys(_ctx.selectedPhotoIdsIndexedByTagId[tag.id]).length !==
                                        0 &&
                                    Object.keys(_ctx.selectedPhotoIdsIndexedByTagId[tag.id]).length ===
                                        Object.keys(_ctx.allPhotoIdsIndexedByTagId[tag.id]).length,
                                indeterminate: _ctx.selectedPhotoIdsIndexedByTagId[tag.id] &&
                                    Object.keys(_ctx.selectedPhotoIdsIndexedByTagId[tag.id]).length <
                                        Object.keys(_ctx.allPhotoIdsIndexedByTagId[tag.id]).length,
                                onClick: ($event) => (_ctx.updateTags(tag.id))
                            }, null, 8, _hoisted_12),
                            _createTextVNode(" " + _toDisplayString(tag.data.name), 1)
                        ]));
                    }), 128)),
                    _hoisted_13,
                    _createElementVNode("button", {
                        class: "my-1 h-fit w-full items-center justify-center rounded-lg bg-green-600 text-base font-bold text-white hover:bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-20",
                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.selectAllPhotos()))
                    }, _hoisted_15),
                    _createElementVNode("button", {
                        class: "my-1 h-fit w-full items-center justify-center rounded-lg bg-green-600 text-base font-bold text-white hover:bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-20",
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.clearSelectedPhotos()))
                    }, _hoisted_17),
                    _createElementVNode("button", {
                        class: "my-1 h-fit w-full items-center justify-center rounded-lg bg-green-600 text-base font-bold text-white hover:bg-opacity-80 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-opacity-20",
                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.submit())),
                        disabled: _ctx.disabledForSubmitButton
                    }, [
                        _createElementVNode("div", _hoisted_19, [
                            (!_ctx.disabledForSubmitButton)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "保存する"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_21, "保存中..."))
                        ])
                    ], 8, _hoisted_18),
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_LinkButton, {
                            path: "photos",
                            name: "一覧に戻る",
                            query: _ctx.$route.query
                        }, null, 8, ["query"])
                    ])
                ])
            ]),
            _createElementVNode("main", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPhotos, (photo, k) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: k,
                            class: "w-24"
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["relative m-auto w-20", { 'border-4 border-rose-500': _ctx.selectedPhotos[photo.id] }]),
                                onClick: ($event) => (_ctx.selectPhoto(photo))
                            }, [
                                (_ctx.selectedPhotos[photo.id] && _ctx.selectedPhotoFilter)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("img", {
                                            src: photo.smallPhotoUrl,
                                            class: _normalizeClass(_ctx.CurrentImageListCss.image)
                                        }, null, 10, _hoisted_28),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["absolute left-0 top-0 h-6 w-6 text-sm font-bold", _ctx.CurrentImageListCss.labelClass])
                                        }, [
                                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.CurrentImageListCss.labelMessage), 1)
                                        ], 2)
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("img", {
                                            src: photo.smallPhotoUrl,
                                            class: _normalizeClass(photo.imageListCss.image)
                                        }, null, 10, _hoisted_31),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["absolute left-0 top-0 h-6 w-6 text-sm font-bold", photo.imageListCss.labelClass])
                                        }, [
                                            _createElementVNode("span", _hoisted_32, _toDisplayString(photo.imageListCss.labelMessage), 1)
                                        ], 2)
                                    ]))
                            ], 10, _hoisted_26),
                            (_ctx.likesIndexedByPhotoId[photo.id]?.likeCount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, " 👍 " + _toDisplayString(_ctx.likesIndexedByPhotoId[photo.id]?.likeCount || 0), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", null, _toDisplayString(_ctx.users[photo.data.uid]?.getRealName() || "Unknown"), 1),
                            _createElementVNode("div", null, _toDisplayString(photo.formatCreatedAt()), 1),
                            (_ctx.tagIdsIndexedByPhotoId[photo.id])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.tagIdsIndexedByPhotoId[photo.id]), (tagId, k) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: k,
                                            class: "m-px inline-block h-3 w-3 rounded-md",
                                            style: _normalizeStyle({ 'background-color': _ctx.Tag.convertToColorHex(tagId) })
                                        }, null, 4));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ])
            ])
        ])
    ]));
}
